import moment from 'moment';
import { getCurrentFY } from '@/app/utils/utils';

export const defaultPensionKitPaymentInstruction = {
  finYear: moment(new Date(getCurrentFY(), 5, 30)).format('YYYY'),
  ratify: null,
  members: {},
  rules: [],
};

export default defaultPensionKitPaymentInstruction;
